/*------------------------------------------------------------------
[Jquery Script]
Project:    Ondho
-------------------------------------------------------------------*/
/* 
==================================================
	Table of Contents
==================================================
* Some useful Tips / Shortcuts
* Scripts
  + setupVariables() from WP
  + webAnalitycs
	+ setTransitionDuration
  + Project functions
	+ Ready 
*/

function openCharacteristics() {
  var overlayCaracteristics = $( '.content-characteristics' );

  if($(this).hasClass('overlay-close')) { // close overlay
    $('.content-characteristics').css('display', 'none');
    $('.tshirt-custom-design').css('display', 'block');
  } else { // open overlay
    $('.content-characteristics').css('display', 'block');
    $('.tshirt-custom-design').css('display', 'none');
  }

  $('.content-characteristics .overlay-close').on('click', openCharacteristics);
}

//Common vars
var device;

// CONFIG.ANIM_PARAMS
var CONFIG = {
	speed: 300,
	scroll_speed: 2000,
	sliders_speed: 300,
	slow_load: false
};

/*
function webAnalitycs(name, param, url) {
  window._gaq.push(['_trackEvent', name, param, url]);
}
*/


/*
  // comentado para nueva versión de los filtros
  jQuery('body').on('change', '.multiSelectOptions [type="checkbox"]', function (a) {
  var name = $(this).closest('.woof_container').attr('data-css-class');
  name = name.replace('woof_container_', '');
  var slug = $(this).val();
    //mode with Filter button
    var values = [];
    jQuery('.woof_container_' + name + ' .multiSelectOptions input:checked').each(function (i, v) {
      values.push(jQuery(this).val());
    });
    
    //duplicates removing
    //http://stackoverflow.com/questions/9229645/remove-duplicates-from-javascript-array
    values = values.filter(function (item, pos) {
        return values.indexOf(item) == pos;
    });

    values = values.join(',');
    if (values.length) {
      woof_current_values[name] = values;
    } else {
      delete woof_current_values[name];
    }

    woof_ajax_page_num = 1;
    if (woof_autosubmit) {
      woof_submit_link(woof_get_submit_link());
    }
});*/

// GA
$("[data-gaevent_category]").on("click", function() {
  // console.log($(this).data("gaevent_category"), $(this).data("gaevent_action"), $(this).data("gaevent_label"));
  _gaq.push(['_trackEvent', $(this).data("gaevent_category"), $(this).data("gaevent_action"), $(this).data("gaevent_label")]);
});
// END GA

// get the WP variables that were exposed to javascript via footer.php
variables.determineWpVariables();
externalLinks(variables.url);

/*
//Funcion para el popUp de la politica de privacidad y aviso legal.
  function animationObject(obj,x) {
	obj.removeClass().addClass(x);
	var wait = window.setTimeout( function(){
		obj.removeClass();
	  } , 1300
	);
  }*/
  
/* Document.ready
---------------------------------------------------------------------------------------- */
$(document).ready(function() {
  $('body').on('click', 'a[rel="popup"]', function(e) {
    e.preventDefault();
    var $el = $(e.currentTarget);
    popUp($el.attr('href'), 480, 600);
  });

  // search form submit
  $('.search-form a').on('click', function(e){
    e.preventDefault();
    $('.search-form').submit();
  });
  // END search form submit

  // checkout politica
  $('body').on('change', '#politica-checkout input[type="checkbox"]', function(e) {
    if ($(this).is(':checked')) {
      $(this).parent().addClass('checked');
    } else {
      $(this).parent().removeClass('checked');
    }
  });
  // END checkout politica

  // checkout submit button
  $('body').on('click', '#woocommerce_checkout_place_order', function(e) {
    e.preventDefault();
    $('form.woocommerce-checkout').submit();
  });
  // END checkout submit button  

  /*
  // comentado para nueva versión de los filtros
  $(".woof_mselect_gama").multiSelect({
    selectAll: false,
    noneSelected: 'Gama',
    oneOrMoreSelected: 'Gama'
  });

  $(".woof_mselect_genero").multiSelect({
    selectAll: false,
    noneSelected: 'Género',
    oneOrMoreSelected: 'Género'
  });

  $(".woof_mselect_tipo").multiSelect({
    selectAll: false,
    noneSelected: 'Tipo prenda',
    oneOrMoreSelected: 'Tipo prenda'
  });

  $(".woof_mselect_deporte").multiSelect({
    selectAll: false,
    noneSelected: 'Deportes',
    oneOrMoreSelected: 'Deportes'
  });

  $prettyDropdown = $('.woof_price_filter_dropdown, .woof_select_deporte, .woof_select_tipo').prettyDropdown();
  */
 
  /*$('#store_province, #store_name').prettyDropdown({
    customClass: 'full-width'
  });*/

  var window_size = $(window).width();


  if($(window).width() < 979) {
    $('.woof_block_html_items').hide();
  }

  $( window ).resize(function() {
    // se queja de que no existe
    //$prettyDropdown.refresh();

    if($(window).width() < 752 && window_size >= 752) {
      $('.testimonials .module-featured').slick({
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        adaptiveHeight: true
      });
    }
    else if($(window).width() >= 752 && window_size < 752) {
      $('.testimonials .module-featured').slick('unslick');
    }

    window_size = $(window).width();
  });

  if($(window).width() < 752) {
    $('.testimonials .module-featured').slick({
      arrows: false,
      dots: true,
      infinite: true,
      speed: 300,
      adaptiveHeight: true
    });
  }

  // MENU
  // clico en la hamburguesa
  $('.c-hamburger').on('click', function(e){
    e.preventDefault();
    var is_active = $(this).hasClass('is-active');

    for (var i = 0; i < $('.main-menu ul > li.parent').length; i++) {
      if(is_active) { // close menu
        var last_element = false;
        if(i == 0) last_element = true;
        toggleMenuMobile($('.main-menu ul > li.parent').eq(i), ($('.main-menu li').length - 1) - i, 'out', last_element);
      } else { // open menu
        if(i == 0) $('.main-menu').addClass('active');
        toggleMenuMobile($('.main-menu ul > li.parent').eq(i), i, 'in');
      }
    }

    $(this).toggleClass('is-active');
  });

  function toggleMenuMobile(element, position, transition, last_element) {
    setTimeout(function() {
      if(transition === 'in') {
        element.addClass('active');
      } else {
        element.removeClass('active');
        if(last_element) $('.main-menu').removeClass('active');
      }
    }, 80 * position);
  }

  if($(window).width() < 768) {
      $('.main-menu ul > li.parent > a').on('click', function (e) {
          e.preventDefault();
          $(this).parent().toggleClass('active-submenu');
      });
  }
  // END MENU

  // Overlay view cart button
  $('.row-designer').on('click', '.tshirtecommerce-designer-cart .close-message', function(e){
    $('.row-designer .tshirtecommerce-designer-cart').fadeOut(function(){
      $('.row-designer .tshirtecommerce-designer-cart').remove();
    });
  });
  // END Overlay view cart button

  ///////////////////////////////////////////////////////////////////////////////
  // OVERLAY - http://tympanus.net/codrops/2014/02/06/fullscreen-overlay-effects/
  var overlay = $( 'div.overlay' );

  $(document).keyup(function(e) { // when escape remove all overlays
    if (e.keyCode == 27) {
      $(overlay).removeClass('open');
      $(overlay).addClass('close');

      $( '.content-characteristics' ).removeClass('open');
      $( '.content-characteristics' ).addClass('close');

      $('body').css('overflow-y', 'auto');
    }
  });

  function toggleOverlay(e) {
    e.preventDefault();
    e.stopPropagation();

    if($(this).hasClass('overlay-close')) { // close overlay
      $(overlay).removeClass('open');
      $(overlay).addClass('close');

      $( '.content-characteristics' ).removeClass('open');
      $( '.content-characteristics' ).addClass('close');

      $('body').css('overflow-y', 'auto');

    } else { // open overlay
      $('body').css('overflow-y', 'hidden');
      $( 'div.overlay[data-overlay="'+$(this).attr('data-href')+'"]' ).removeClass('close').addClass('open');

      // if buscador fer focus
      /*if($(this).attr('data-href') == 'open-buscador') {
        $('.search-form [type="search"]').trigger('focus');
      }*/
    }
  }

  $('.trigger-overlay, .overlay-close').on('click', toggleOverlay);
  // END OVERLAY

  // GUIA DE TALLAS
  $('.menu-sport a').on('click', function(e){
    e.preventDefault();
    $('.menu-sport a').removeClass('active');

    $(this).addClass('active');
    var currentHref = $(this).attr('href');

    $('.gender-menu ul').removeClass('active');

    var $menu_gender = $('.gender-menu [data-sport="' + currentHref + '"]');
    $menu_gender.addClass('active');
    $menu_gender.find('a').removeClass('active');
    $($menu_gender.find('a')[0]).addClass('active');

    $('.tallas').removeClass('active');

    $($($menu_gender.find('a')[0]).attr('href')).addClass('active');

    // como medir
    if(currentHref == 'entrenamiento-paseo') {
      $(".como-medir").removeClass("active");
      $(".como-medir").hide();
    } else {
      $(".como-medir").show();
      var currentGender = $($menu_gender.find("a")[0]).attr("href").split("-")[1];
      $(".como-medir [data-gender]").removeClass("active");
      $('.como-medir [data-gender="' + currentGender + '"]').addClass("active");
    }
  });

  $('.gender-menu a').on('click', function(e){
    e.preventDefault();

    $('.gender-menu a').removeClass('active');
    $(this).addClass('active');

    $('.tallas').removeClass('active');

    $($(this).attr('href')).addClass('active');

    // como medir
    var currentGender = $(this).attr('href').split('-')[1];
    $('.como-medir [data-gender]').removeClass('active');
    $('.como-medir [data-gender="' + currentGender + '"]').addClass('active');
  });

  if ( ($('body').hasClass('woocommerce-page')) && ($( '#woof_wrapper' ).length) ) {
    console.log('estoy en archivos y con filtros');

    $('#woof_wrapper').append( $('.woof_redraw_zone') );

    if ( $( '.woof_products_top_panel' ).length ) {
      $('.woof_products_top_panel').insertBefore($('.woof_redraw_zone'));
    }

    var $newTitle = $( "<h3>Filtros</h3>" );
    setTimeout(function() {
      $('#woof_wrapper .woof_products_top_panel').prepend( $newTitle );
    }, 0);

  }

  if ( ($('body').hasClass('archive')) ) {
      $(document).on("click", "#woof_wrapper .woof_container_inner h4", function(event){
          event.preventDefault();
          $(this).next('.woof_block_html_items').slideToggle();
      });
  }


  if ( ($('body').hasClass('home')) ) {

      if($(window).width() <= 768) {
          $(document).on('click', '#wrapper .deportes-wrapper .module-deporte .image-wrapper', function(e) {
              e.preventDefault();
              var $el = $(this).parent();
              console.log($el);
              $('#wrapper .deportes-wrapper .module-deporte').removeClass('active');
              $el.addClass("active");
              console.log('clico en la imagen');
          });
      } else {
          $('#wrapper .deportes-wrapper .module-deporte').hover(
              function () {
                  $(this).addClass('hover');
              },
              function () {
                  $(this).removeClass('hover');
              }
          );
      }

  }

  //change name
/*  jQuery.fn.justtext = function() {
      var textReturn = $(this).clone().children().remove().end().text();
      //console.log(textReturn);
      return textReturn;
  };

  $( ".woof_container_inner h4" ).each(function() {
      var newText = $(this).justtext();
      var newHTML = $(this).children('a').text(newText).clone();
      $(this).empty();
      $(this).append(newHTML);
      //console.log(newText);
  });*/

});